import { ReactElement } from 'react';

export interface Props {
  condition: boolean
  renderWrapper: () => ((children: ReactElement) => ReactElement);
  children: ReactElement;
}

export default function ConditionalWrapper({ condition, renderWrapper, children }: Props) {
  const wrapper = renderWrapper();

  return condition ? wrapper(children) : children;
}
